<template>
    <div class="data-wrapper-core">
        <h3>Kerndaten</h3>
        <v-divider></v-divider>
        <h4>Lead-Name:</h4>
        <p>{{ leads.name }}</p>
        <h4>Status:</h4>
        <p>{{ leads.status }}</p>
        <h4>Erstelldatum:</h4>
        <p>{{ leads.createdAt }}</p>
        <h4>Lead-ID:</h4>
        <p>{{ leads._id }}</p>
        <h4>Source:</h4>
        <p>{{ leads.source }}</p>
        <h4>Telefon:</h4>
        <p>{{ leads.phone }}</p>
        <h4>Email:</h4>
        <p>{{ leads.email }}</p>
        <h4>Letzte Änderung:</h4>
        <p>{{ leads.lastChange }}</p>    
    </div>
</template>

<script>
    export default {
        props: {
            leads: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>